import { createFileRoute } from '@tanstack/react-router';

import { AgencyOnboarding } from '@/components/agency/onboarding/agency-onboarding';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/onboarding')({
  loader: () => loadNamespaces('agency'),
  staticData: {
    title: 'route.agency_onboarding.title',
  },
  component: AgencyOnboarding,
});
